const LAYERS = {
    BACKGROUND: 0,
    WALLS: 1,
    "Painted Walls": 5,
    LIQUIDS: 3,
    TILES: 2,
    "Painted Tiles": 6,
    WIRES: 4
}

export default Object.freeze(LAYERS);